import Vue from 'vue'
import Vuex from 'vuex'

import AuthModule from './modules/auth.js';
import AlertKegModule from './modules/alertKeg.js';
import ApiModule from './modules/api.js';
import DialogsModule from './modules/dialogs.js';
import KegModule from './modules/keg.js';
import ClientModule from './modules/client.js';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: AuthModule,
    api: ApiModule,
    dialogs: DialogsModule,
    keg: KegModule,
    client: ClientModule,
    alertKeg: AlertKegModule,
  },
  state: {
    storeBusy: [],

    mobileSideBarShow: false,
    clothColors: [],
    clothCategories: [],
  },
  getters: {
    isStoreBusy(state) {
      return state.storeBusy.length > 0;
    },
    isMobileSideBarShow(state) {
      return state.mobileSideBarShow;
    }
  },
  mutations: {
    APPENDBUSY(state, payload) {
      const index = state.storeBusy.indexOf(payload);
      if (index === -1) {
        state.storeBusy.push(payload);
      }
    },
    CLEARBUSY(state, payload) {
      const index = state.storeBusy.indexOf(payload);
      if (index !== -1) {
        state.storeBusy.splice(index, 1);
      }
    },
    SETCLOTHCATEGORIES(state, payload) {
      state.clothCategories.splice(0, state.clothCategories.length);
      for (const category of payload) {
        state.clothCategories.push(category);
      }
    },
    SETCLOTHCOLORS(state, colors) {
      state.clothColors.splice(0, state.clothColors.length);
      for (const color of colors) {
        state.clothColors.push(color);
      }
    },
    SETMOBILESIDEBAR(state, show) {
      state.mobileSideBarShow = show;
    }
  },
  actions: {
    appendComponentBusy(context, busyName) {
      context.commit("APPENDBUSY", busyName);
    },
    clearComponentBusy(context, busyName) {
      context.commit("CLEARBUSY", busyName);
    },
    showMsg(context, msg) {
      alert(msg);
    },
    async refreshClothCategories(context) {
      const busyName = 'REFRESHCLOTHCATEGORIES';
      context.commit("APPENDBUSY", busyName);
      try {
        const categories = await context.dispatch('api/readClothCategoryPromise');
        context.commit("SETCLOTHCATEGORIES", categories);
      } catch (e) {
        console.error(e);
      } finally {
        context.commit("CLEARBUSY", busyName);
      }
    },
    async refreshClothColors(context) {
      const busyName = 'REFRESHCLOTHCOLORS';
      context.commit("APPENDBUSY", busyName);
      try {
        const colors = await context.dispatch('api/readClothColorPromise');
        context.commit("SETCLOTHCOLORS", colors);
      } catch (e) {
        console.error(e);
      } finally {
        context.commit("CLEARBUSY", busyName);
      }
    },
    getCategoryName(context, serial) {
      for (const c1 of context.state.clothCategories) {
        if (c1.serial === serial) {
          return c1.name;
        }
        for (const c2 of c1.sub) {
          if (c2.serial === serial) {
            return c2.name;
          }
        }
      }
      return '';
    },
    setMobileSideBarShow(context, show) {
      context.commit('SETMOBILESIDEBAR', show);
    },
  },
})
